import IconDown from '../icons/down';
import IconArrowLeft from '../icons/arrow-left';
import { PrimaryAccountsListTypes } from './types';

import styles from './accounts-selector.module.css';
import Checkbox from '../checkbox/checkbox';

export default function PrimaryAccountsList({
  setSelectedPrimaryAccountId,
  selectedGroup,
  onBack,
  selectedCategoryNumber,
  setAccountQuery,
  selectedCategoryId,
  primaryAccountsSelector,
  setSelectedPrimaryAccounts,
  selectedPrimaryAccountsList,
}: PrimaryAccountsListTypes) {
  return (
    <>
      <li className={styles.groupsTitle}>
        <button type="button" className={styles.backButton} onClick={onBack}>
          <IconArrowLeft />
          <div
            className={styles.categoryTitle}
          >{`${selectedCategoryNumber}.${selectedGroup?.number} ${selectedGroup?.description}`}</div>
        </button>
      </li>
      {selectedGroup?.primaryAccounts?.map((item) => (
        <li
          key={item.id}
          className={`${styles.primaryAccountRow} ${primaryAccountsSelector ? styles.primaryAccountsSelectorListItem : ''}`}
        >
          <div
            className={
              primaryAccountsSelector
                ? `${styles.categoryButtonWrapper} ${styles.primaryAccountCategoryButtonWrapper}`
                : ''
            }
          >
            {primaryAccountsSelector && setSelectedPrimaryAccounts && (
              <>
                <div className={styles.selectAllCheckboxWrapper}>
                  <Checkbox
                    name={`category-${item.id}`}
                    type="checkbox"
                    title={item.description}
                    checked={Boolean(
                      selectedPrimaryAccountsList?.find(
                        (primary) => primary === item.id,
                      ),
                    )}
                    onChange={(e) => {
                      let nextSelectedPrimaryAccounts = ([] as string[]).concat(
                        selectedPrimaryAccountsList as string[],
                      );

                      if (e.target.checked) {
                        nextSelectedPrimaryAccounts.push(item.id);
                      } else {
                        nextSelectedPrimaryAccounts =
                          nextSelectedPrimaryAccounts.filter(
                            (selectedPrimary) => item.id !== selectedPrimary,
                          );
                      }

                      setSelectedPrimaryAccounts(nextSelectedPrimaryAccounts);
                    }}
                  />
                </div>
                <div
                  className={`${styles.categoryButtonNumber} ${styles.primaryAccountButtonNumber}`}
                >{`${selectedCategoryNumber}.${selectedGroup.number}.${item.number}`}</div>
              </>
            )}
            {!primaryAccountsSelector && (
              <button
                type="button"
                className={`${styles.categoryButton} ${primaryAccountsSelector ? styles.primaryAccountsSelectorButton : ''}`}
                onClick={() => {
                  setSelectedPrimaryAccountId(item.id);
                  setAccountQuery(
                    `categoryId=${selectedCategoryId}&groupId=${selectedGroup.id}&primaryId=${item.id}`,
                  );
                }}
                tabIndex={-1}
                disabled={primaryAccountsSelector}
              >
                <div
                  className={`${styles.categoryButtonLeft} ${styles.primaryAccountButtonLeft}`}
                >
                  {item.description}
                </div>
                <div className={styles.categoryButtonRight}>
                  <div
                    className={`${styles.categoryButtonNumber} ${styles.primaryAccountButtonNumber}`}
                  >{`${selectedCategoryNumber}.${selectedGroup.number}.${item.number}`}</div>

                  <div className={styles.categoryButtonArrow}>
                    <IconDown
                      className={`${styles.arrowRight} ${styles.primaryAccountArrowRight}`}
                      width={12}
                      height={9}
                    />
                  </div>
                </div>
              </button>
            )}
          </div>
        </li>
      ))}
    </>
  );
}
